import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";

const PriceBox: React.FC<any> = (props) => {

    const isMobile = useMediaQuery({ query: `(max-width : 1024px)` });

    return (
        <div style={{
            width : "100%",
            marginTop : !isMobile ? "20px" : "12px"
        }}>
            {
                props.price && 
                <div style={{
                    width : "100%",
                    backgroundColor : "#F0F3F8",
                    display : "flex",
                    justifyContent : "space-between",
                    alignItems : "center",
                    paddingLeft : !isMobile ? "20px" : "15px",
                    paddingRight : !isMobile ? "20px" : "15px",
                    fontWeight : 700,
                    fontSize : !isMobile ? "21px" : "13.5px",
                    paddingTop : !isMobile ? "16px" : "12px",
                    paddingBottom : !isMobile ? "16px" : "12px",
                    borderRadius : "8px"
                }}>
                    <div>
                        등록비
                    </div>
                    <div>
                        {props.price}
                    </div>
                </div>
            }
            {
                props.price2 &&
                <div style={{
                    width : "100%",
                    backgroundColor : "#F0F3F8",
                    display : "flex",
                    justifyContent : "space-between",
                    alignItems : "center",
                    paddingLeft : !isMobile ? "20px" : "15px",
                    paddingRight : !isMobile ? "20px" : "15px",
                    fontWeight : 700,
                    fontSize : !isMobile ? "21px" : "13.5px",
                    marginTop : !isMobile ? "10px" : "4px",
                    paddingTop : !isMobile ? "16px" : "12px",
                    paddingBottom : !isMobile ? "16px" : "12px",
                    borderRadius : "8px"
                }}>
                    <div>
                        재학생 (학기중)
                    </div>
                    <div>
                        {props.price2}
                    </div>
                </div>
            }
        </div>
    )
}

export default PriceBox;